document.querySelector("html").classList.remove("no-js");

let logs = false;

// Checks
const body = document.querySelector("body");
const indexCheck = document
  .querySelector("body")
  .classList.contains("template-index");
const productCheck = document
  .querySelector("body")
  .classList.contains("template-product");
const formCheck = document.getElementById("add-to-cart-form") !== null;
const qtyCheck = document.querySelector(".js-quantity-picker") !== null;
const lineQtyCheck = document.querySelector("quantity-selector") !== null;
const instaCheck = document.querySelector(".section-instagram-feed") !== null;
const gridSectionCheck = document.querySelector(".grid-slider") !== null;
const collectionCheck = document.querySelector(".collection-grid") !== null;
const sizeGuideCheck = document.querySelector(".size-guide__link") !== null;
const annCheck = document.querySelector(".announcement-bar") !== null;
const swatchCheck = document.querySelector(".color-option") !== null;
const searchCheck = document.getElementById("results-grid") !== null;

// Widths
const px1024 = window.matchMedia("(max-width: 1024px)").matches;
const pxDesktop = window.matchMedia("(min-width: 1024px)").matches;

if (
  navigator.userAgent.indexOf("Safari") != -1 &&
  navigator.userAgent.indexOf("Chrome") == -1
) {
  body.classList.add("browser-safari");
}

/* Feature detection */
let passiveIfSupported = false;

try {
  window.addEventListener(
    "test",
    null,
    Object.defineProperty({}, "passive", {
      get() {
        passiveIfSupported = { passive: true };
      },
    })
  );
} catch (err) {}

// Debounce function to limit the rate at which a function can fire
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Swatches Names

function swatchNames() {
  let swatches = document.querySelectorAll(".color-option"),
    mainName = document.querySelector(".radio__title"),
    mainNameStore = mainName.dataset.current;

  swatches.forEach((swatch) => {
    swatch.addEventListener("mouseover", function () {
      let newName = swatch.querySelector(".radio--color").dataset.name;
      mainName.textContent = newName;
    });

    swatch.addEventListener("mouseout", function () {
      mainName.textContent = mainNameStore;
    });
  });
}

// if (swatchCheck) {
//   swatchNames();
// }

// Mobile Menu
// class MobileMenu {
//   constructor(target) {
//     target.addEventListener("click", this.onMenuClick.bind(this));
//   }

//   onMenuClick(event) {
//     event.preventDefault();
//     let htmlEl = document.querySelector("html"),
//         menuCheck = htmlEl.classList.contains("menu-active"),
//         button = event.target.closest("button");

//       console.log("menu click");
//       console.log(button);

//     if (!menuCheck) {
//       htmlEl.classList.add("menu-active");
//       button.setAttribute("aria-expanded", "true");
//     } else {
//       htmlEl.classList.remove("menu-active");
//       button.setAttribute("aria-expanded", "false");
//     }
//   }
// }

function desktopFilterOverflow() {
  if (!px1024) {
    let overflowElement = document.querySelector(".js-facets-overflow");
    if (overflowElement !== null) {
      let overflowParent = overflowElement.parentNode,
        setWidth = overflowParent.offsetWidth;
      overflowElement.style.setProperty(
        "--overflow-width",
        `calc(${setWidth}px - 7.5rem)`
      );
      // console.log("overflow width set to " + setWidth);
    }
  }
}









const menuLinks = document.querySelectorAll(".js-menu-link");
const htmlEl = document.querySelector("html");
const menu = document.querySelector(".mobile-menu");

function toggleMenu() {
  console.log("toggleMenu called");
  const menuCheck = htmlEl.classList.contains("menu-active");

  if (!menuCheck) {
    htmlEl.classList.add("menu-active");
    menuLinks.forEach((link) => {
      link.setAttribute("aria-expanded", "true");
      link.setAttribute("aria-label", "Close menu");
    });
    menu.setAttribute("aria-hidden", "false");
  } else {
    htmlEl.classList.remove("menu-active");
    menuLinks.forEach((link) => {
      link.setAttribute("aria-expanded", "false");
      link.setAttribute("aria-label", "Open menu");
    });
    menu.setAttribute("aria-hidden", "true");
  }
}

function mobileMenu(button) {
  if (!button.dataset.listenerAdded) {
    // console.log("Adding event listener to button");
    button.addEventListener("click", debounce(toggleMenu, 100));
    button.dataset.listenerAdded = true; // Mark the button as having an event listener
  } else {
    // console.log("Listener already added to button");
  }
}

menuLinks.forEach((link) => {
  mobileMenu(link);
});

let isReadMoreOpen = false;


function onReadMoreClick(button) {
  let buttonParent = button.parentNode;
   

    if (isReadMoreOpen) {
      // console.log("read less button clicked");
      buttonParent.classList.remove("is-open");

      buttonParent
        .querySelector(".product-main__description-ext .description-full")
        .classList.add("visually-hidden");

      buttonParent
        .querySelector(".product-main__description-ext .description-excerpt")
        .classList.remove("visually-hidden");

      setTimeout(function () {
        buttonParent
          .querySelector(".product-main__description .description-full")
          .classList.add("js-fade");
      }, 320);
      button.textContent =
        button.textContent === "Read more" ? "Read less" : "Read more";
      isReadMoreOpen = false;

    } else {

      buttonParent.classList.add("is-open");

      buttonParent
        .querySelector(".product-main__description-ext .description-full")
        .classList.remove("visually-hidden");

      buttonParent
        .querySelector(".product-main__description-ext .description-excerpt")
        .classList.add("visually-hidden");

      setTimeout(function () {
        buttonParent
          .querySelector(".product-main__description .description-full")
          .classList.remove("js-fade");
      }, 320);
      button.textContent =
        button.textContent === "Read more" ? "Read less" : "Read more";
      isReadMoreOpen = true;
    }

}

function readMore(button) {
  button.addEventListener("click", function (event) {
    event.preventDefault();
    onReadMoreClick(button);
  });
};


var extendedDescription = document.querySelector(".product-main__description-ext") !== null;

function revealLogo() {
  if (pxDesktop) {
    let header = document.querySelector("header"),
      html = document.querySelector("html");

    const hiddenNavItems = document.querySelectorAll(".nav-hidden");

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            hiddenNavItems.forEach((item) => {
              item.classList.add("visually-hidden");
              // item.classList.add("animate--fadeOut");
              item.classList.remove("animate--fadeIn");
            });
            html.classList.remove("secondary-logo");
          } else {
            hiddenNavItems.forEach((item) => {
              item.classList.remove("visually-hidden");
              // item.classList.remove("animate--fadeOut");
              item.classList.add("animate--fadeIn");
            });
            html.classList.add("secondary-logo");
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      }
    );

    observer.observe(header);
  }
}

// if (!indexCheck && !productCheck) {
//   revealLogo();
// }

// Announcement Bar
function annBar() {
  let annBar = document.querySelector(".announcement-bar"),
    annClose = document.querySelector(".announcement-bar .js-close"),
    slider = document.querySelector(".announcement-bar__carousel"),
    html = document.querySelector("html"),
    bannerCheck = html.classList.contains("hide-banner");

  if (!Shopify.designMode && sessionStorage.hasOwnProperty("annHide")) {
    // console.log("banner previously hidden");
    html.classList.add("hide-banner");
    annBar.style.display = "none";
  } else {
    if (!bannerCheck) {
      html.classList.add("show-banner");
      // console.log("banner already showing");

      if (slider) {
        var annflkty = new Flickity(slider, {
          wrapAround: true,
          prevNextButtons: false,
          cellSelector: ".announcement-bar__cell",
          autoPlay: 4000,
          pageDots: false,
          setGallerySize: false,
          fade: true,
        });
      }

      annClose.addEventListener("click", function (event) {
        event.preventDefault();

        html.classList.remove("show-banner");
        annBar.style.display = "none";

        window.sessionStorage.setItem("annHide", "true");
        window.sessionStorage.setItem("origin", "https://labourandwait.co.uk");
      });
    }
  }
}

// if (annCheck) {
// annBar();
// }

function slider(carousel, index) {
  if (productCheck && !px1024) {
    // If Desktop PDP
    if (carousel.dataset.autoplay == "true" && !Shopify.designMode) {
      var autoPlay = 4000;
    } else {
      var autoPlay = false;
    }

    var flkty = new Flickity(carousel, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      fade: true,
      cellAlign: "left",
      autoPlay: autoPlay,
      cellSelector: ".carousel-cell",
      setGallerySize: false,
    });

    // console.log(autoPlay);

    const carouselNav = carousel.nextElementSibling;
    // If Carousel Nav Exists
    if (carouselNav && carouselNav.classList.contains("carousel__nav")) {
      var flktyNav = new Flickity(carouselNav, {
        asNavFor: carousel,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: false,
        cellAlign: "left",
        groupCells: 2,
        wrapAround: true
      });
    }
  } else if (px1024) {
    // If Mobile

    // if (productCheck) {
    //   var fade = false;
    // } else {
    //   var fade = true;
    // }

    if (carousel.dataset.autoplay == "true" && !Shopify.designMode) {
      var autoPlay = 4000;
    } else {
      var autoPlay = false;
    }

    var flkty = new Flickity(carousel, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      fade: true,
      cellAlign: "left",
      autoPlay: autoPlay,
      setGallerySize: false,
    });
  } else {
    // if Desktop, not PDP
    if (carousel.dataset.autoplay == "true" && !Shopify.designMode) {
      var autoPlay = 4000;
    } else {
      var autoPlay = false;
    }

    var flkty = new Flickity(carousel, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      draggable: false,
      fade: true,
      cellAlign: "left",
      autoPlay: autoPlay,
      setGallerySize: false,
    });

    // console.log(autoPlay);

    // click to change slide
    carousel.addEventListener("click", function (event) {
      event.preventDefault();
      flkty.next();
    });
  }

  if (Shopify.designMode) {
    flkty.select(index, true, true);
  }
}

let carouselCheck = document.querySelector(".carousel"),
  carousels = document.querySelectorAll(".carousel");

// if (carouselCheck) {
//   carousels.forEach((carousel) => {
//     slider(carousel);
//   });
// }

// // window resize, destroy and reinit carousel

// window.addEventListener("resize", function () {
//   if (carouselCheck) {
//     carousels.forEach((carousel) => {
//       let flkty = Flickity.data(carousel);

//       if (flkty) {
//         flkty.destroy();
//         slider(carousel);
//       }
//     });
//   }
// });

// Search Form
class SearchForm {
  constructor(target) {
    target.addEventListener("keyup", this.onSearchInputKeyUp.bind(this));
  }

  onSearchInputKeyUp(event) {
    let form = event.target.closest("form"),
      button = form.querySelector(".js-search-submit"),
      shouldDisableButton = event.target.value.length === 0;

    // console.log("disable search " + shouldDisableButton);

    if (shouldDisableButton) {
      button.setAttribute("disabled", true);
      button.classList.add("btn-disabled");
      button.classList.add("opacity-025");
    } else {
      button.classList.remove("btn-disabled");
      button.classList.remove("opacity-025");
      button.removeAttribute("disabled");
    }
  }
}

let searchInput = document.querySelectorAll(".js-search-input");

// if (searchInput) {
//   searchInput.forEach((search) => {
//     new SearchForm(search);
//   });
// }


function updateScrollPath(container) {
  if (!container) return; // Prevent errors if container is missing
  if (logs) {
    console.log("updateScrollPath", container);
  }
  const filterUrl = window.location.href;

  // const shopUrl = container.dataset.root;
  // const afterDomain = filterUrl.split(".com");
  // const path = afterDomain[1];

  let path;
  if (filterUrl.includes('127.0.0.1') || filterUrl.includes('localhost')) {
    // For local development
    const urlObj = new URL(filterUrl);
    path = urlObj.pathname + urlObj.search;
  } else {
    // For production URLs with .com domain
    const afterDomain = filterUrl.split(".com");
    path = afterDomain[1];
  }
  const url = new URL(filterUrl);
  url.searchParams.delete('page'); // Remove existing page parameter
  
  // Reconstruct clean path
  if (filterUrl.includes('127.0.0.1') || filterUrl.includes('localhost')) {
    path = url.pathname + url.search;
  } else {
    path = url.pathname + url.search;
  }

  container.dataset.path = path;
  
  // Check if URL has active filter
  if (url.search === "" || url.searchParams.toString() === "") {
    if (logs){
      console.log("No active filter found", filterUrl)
      console.log("Setting path to", path);
    };
    container.dataset.filter = "false";
    return;
  } else {
    // container.dataset.path = path;
    container.dataset.filter = "true";
    if (logs) console.log("Active filter found", path);
  }
}

const productGrid = document.getElementById("product-grid");
const articleGrid = document.getElementById("article-grid");

let infiniteScrollInitialized = false;


function initInfiniteScroll() {
  const productGrid = document.getElementById("product-grid");
  const articleGrid = document.getElementById("article-grid");
  const searchGrid = document.getElementById("results-grid");

  
  // Detect if running locally
  const history = 'replace'

  if (logs) console.log("initInfiniteScroll replace history called");
  
  if (productGrid) {

    const pagination = productGrid?.parentNode.querySelector(".pagination");

    if (productGrid && pagination && productGrid.getAttribute("data-scroll") === "true") {
      // Disable history for all collections to prevent back button issues
      // When navigating back to a page URL, only that page's content exists in DOM
      // Users can scroll freely without URL changes - back button goes to previous website
      const historyOption = false;
      new InfiniteScroll(productGrid, {
        path: 'a.pagination__step.next',
        append: 'li.product-card',
        hideNav: 'nav.pagination',
        status: '.page-load-status',
        history: historyOption,
        onInit: function () {
          this.on("load", function (event, body, path, response) {
            if (logs) {
              console.log("Infinite Scroll load");
              console.log("Next path:", path); 
            } 
            infiniteScrollInitialized = true;
            cartScripts();
          });
          this.on("append", function (body, path, items, response) {
            items.forEach((item) => {
              const addToCartBtns = item.querySelectorAll('.quick-add-to-cart-button');
              addToCartBtns.forEach((btn) => {
                if (logs) console.log("Replacing button to remove event listeners");
                btn.replaceWith(btn.cloneNode(true));
              });
            });
            cartScripts();
          });
        },
        onError: function () {
          console.log("Infinite Scroll error");
          document.querySelector("nav.pagination").style.display = "flex";
        }
      
      });
      
    }
  }
  
  if (articleGrid) {
    const pagination = articleGrid?.parentNode.querySelector(".pagination");
    
    if (productGrid && pagination && articleGrid.getAttribute("data-scroll") === "true") {
      const historyOption = false;
      new InfiniteScroll(articleGrid, {
        path: 'a.pagination__step.next',
        append: 'li.article-card',
        hideNav: 'nav.pagination',
        status: '.page-load-status',
        history: historyOption,
        onInit: function () {
          this.on("load", function (event, body, path, response) {
            if (logs) {
              console.log("Infinite Scroll load");
            }
            infiniteScrollInitialized = true;
          });
          this.on("append", function (body, path, items, response) {
            // Ensure any new content has proper event listeners
            cartScripts();
          });
        },
         onError: function () {
          console.log("Infinite Scroll error");
          document.querySelector("nav.pagination").style.display = "flex";
        }
      });
    }
  }

  if (searchGrid) {
    const pagination = searchGrid?.parentNode.querySelector(".pagination");
    if (searchGrid && pagination && searchGrid.getAttribute("data-scroll") === "true") {
      const historyOption = false; 
      new InfiniteScroll(searchGrid, {
        path: 'a.pagination__step.next',
        append: 'li',
        hideNav: 'nav.pagination',
        status: '.page-load-status',
        history: historyOption,
        onInit: function () {
          this.on("load", function (event, body, path, response) {
            if (logs) {
              console.log("Infinite Scroll load");
            }
            infiniteScrollInitialized = true;
          });
          this.on("append", function (body, path, items, response) {
            // Ensure any new content has proper event listeners
            cartScripts();
          });
        },
         onError: function () {
          console.log("Infinite Scroll error");
          document.querySelector("nav.pagination").style.display = "flex";
        }
      });
    }
  }
}

// function infScroll(container, append) {

//   if (infiniteScrollInitialized) {
//     if (logs) console.log("infScroll already initialized, skipping");
//     return;
//   }

//   if (!container) {
//     console.warn("infScroll: container is null or undefined");
//     return;
//   }
//   const parent = container.parentNode;

//   if (!parent) {
//     console.warn("infScroll: parent is null or undefined");
//     return;
//   }

//   // Set up scroll path and filter
//   updateScrollPath(container);

//   // Get pagination and control elements
//   const pagination = parent.querySelector(".pagination");
//   const viewMore = parent.querySelector(".view-more");
//   const btt = parent.querySelector(".btt-anchor");
//   const filterCheck = container.dataset.filter === "true";
//   const partsCount = pagination
//     ? parseInt(pagination.dataset.partsCount, 10)
//     : 0;
//   const currentLimit = container.dataset.limit
//     ? parseInt(container.dataset.limit, 10)
//     : 0;

//     let appendInstance = 1, // Track how many times append has run
//         currentPage = 2, // Start at 2 since page 1 is already loaded
//         path = "a.pagination__step.next";

//   // if (filterCheck) {
//   //   path = container.dataset.path + "&page={{#}}";
//   // } else {
//   //   path = container.dataset.path + "?page={{#}}";
//   // }

//   if (logs) {
//       console.log("infiniteScroll - pagination partsCount = ", partsCount);
//       console.log("infiniteScroll - currentLimit = ", currentLimit);
//       console.log("infiniteScroll - append = ", append);
//   }

//   if (!pagination) {
//       if (logs) console.log("no pagination, no infinite scroll");
//       if (btt) {
//         btt.classList.add("visually-hidden");
//         btt.classList.remove("btt-active");
//       }
//       return;
//     }

//   // Check if infinite scroll is enabled
//   const infScrollActive = container.getAttribute("data-scroll");

//   if (infScrollActive !== "true") {
//     if (logs) console.log("infinite scroll disabled in settings");
//     return;
//   } else {
  
//     if (logs) console.log("infinite scroll active");
//     infiniteScrollInitialized = true;
//     // Initialize InfiniteScroll
  
//       infiniteScroll = new InfiniteScroll(container, {
//         // options
//         hideNav: ".pagination",
//         path: function () {
//             if (currentPage <= partsCount) {
//               const separator = container.dataset.path.includes('?') ? '&' : '?';
//               return container.dataset.path + separator + "page=" + currentPage;
//             } else {
//               return null; // Stop when max page reached
//             }
//           },
//         append: append,
//         status: ".page-load-status",
//         history: "push",
//         historyTitle: true,
//         onInit: function () {
//           this.on("load", function (event, body, path, response) {
//             if (logs) {
//               console.log("Infinite Scroll load");
//               console.log("Infinite Scroll collection limit = " + currentLimit);
//             }
//           });
//           this.on("request", function (path) {
//             // console.log("Infinite Scroll request");
//             // viewMoreText.textContent = "Loading";
//             // console.log("Infinite Scroll requesting:", path)
//           });
//           this.on("append", function (body, path, items, response) {
//             items.forEach((item) => {
//               item.setAttribute("data-append", currentPage);
//             });
//             if (logs) {
//               console.log("Infinite Scroll append - instance:", appendInstance);
//               console.log("currentPage = " + currentPage);
//               console.log("items length = " + items.length);
//               if (items.length > 0) {
//                 console.log(
//                   "Page:" + currentPage + " First item handle:",
//                   items[0].dataset.handle,
//                   " - Page:",
//                   items[0].dataset.page,
//                   " - Index:",
//                   items[0].dataset.index,
//                 );
//                 console.log(
//                   "Page:" + currentPage + " Last item handle:",
//                   items[items.length - 1].dataset.handle,
//                   " - Page:",
//                   items[items.length - 1].dataset.page,
//                   " - Index:",
//                   items[items.length - 1].dataset.index,
//                 );
//               }
            
//                 if (btt) {
//                   btt.classList.remove("visually-hidden");
//                   btt.classList.add("btt-active");
//                 }
//                 if (logs) {
//                   console.log("Infinite Scroll append body HTML - ", body);
//                   console.log("Infinite Scroll append path - " + path);
//                   console.log("Infinite Scroll collection limit = " + currentLimit);
//                   console.log("Infinite Scroll append length - " + items.length);
//                   console.log("Infinite Scroll append response - " + response.status);
//                   console.log("Infinite Scroll next page - " + currentPage);
//                   console.log("Infinite Scroll append - " + append);
//                 }
//             }
//             currentPage++; // Increment page for next request
//             appendInstance++;
            
//             cartScripts();
//             // runScripts();
//           });
//           this.on("error", function () {
//             console.log("Infinite Scroll error");
//             document.querySelector(".pagination").style.display = "flex";
//           });
//               // Event: Last page reached
//           this.on("last", function () {
//             if (logs) {
//               console.log("Infinite Scroll last, path= null");
//             }
//           });
//         },
//       });
//     }
// }

// if (productGrid) {
//   let latestProductGrid = document.querySelector(
//     "#ProductGridContainer #product-grid"
//   );
//   append = "li.product-card";
//   infScroll(latestProductGrid, append);
// }

// if (articleGrid) {
//   let latestArticleGrid = document.querySelector("#article-grid");
//   append = "li.article-card";
//   infScroll(latestArticleGrid, append);
// }

if (productCheck && sizeGuideCheck) {
  MicroModal.init({
    onShow: (modal) => console.info(`${modal.id} is shown`), // [1]
    onClose: (modal) => console.info(`${modal.id} is shown`), // [2]
    openClass: "is-open", // [5]
    disableScroll: true, // [6]
    disableFocus: false, // [7]
    debugMode: true, // [10]
  });
}

function infScrollReset() {
  if (typeof infiniteScroll !== "undefined" && infiniteScroll !== null) {
    console.log("reset inf scroll");
   
    infiniteScrollInitialized = false;
    infiniteScroll.destroy();
    initInfiniteScroll();
  } else {
    console.warn("infiniteScroll is not defined or is null.");
  }
}




 

function zoomProduct(zoomers) {
  const isMobile = window.matchMedia("(max-width: 1024px)").matches;

  if (isMobile) {
    // console.log("zoom disabled on mobile");    path: 'a.pagination__step.next'
    return;
  } else {
    // console.log("zoom enabled");
    zoomers.forEach((zoomer) => {
      if (!zoomer.classList.contains('event-attached')) {
        zoomer.classList.add('event-attached');
        
        const preview = zoomer.querySelector(".carousel-cell__main");
        const zoom = zoomer.querySelector(".carousel-cell__zoom");
        const button = zoomer.querySelector(".carousel-cell__zoom-icon");
        const zoomCheck = zoomer.classList.contains("zoomed");

        zoomer.addEventListener("click", function (e) {
          // console.log("zoomer click");
          if (!zoomCheck) {
            // console.log("add zoomed class button click");

            e.preventDefault();

            this.classList.toggle("zoomed");

            this.addEventListener("mousemove", function (event) {
              const w = zoomer.offsetWidth;
              const h = zoomer.offsetHeight;

              const diffW = zoom.offsetWidth - w;
              const diffH = zoom.offsetHeight - h;

              const percentX = event.offsetX / w;
              const percentY = event.offsetY / h;

              const pixelsX = percentX * -1 * diffW;
              const pixelsY = percentY * -1 * diffH;

              zoom.style.left = pixelsX + "px";
              zoom.style.top = pixelsY + "px";
            });

            this.addEventListener("mouseleave", function () {
              setTimeout(() => {
                zoom.style.left = "0px";
                zoom.style.top = "0px";
              }, 1000);
              this.classList.remove("zoomed");
            });

            this.addEventListener("click", function () {
              zoom.style.left = "0px";
              zoom.style.top = "0px";
            });
          }
        });
      }
    });
  }
}

const zoomers = document.querySelectorAll(".carousel-cell.zoomer");
const zoomerCheck = document.querySelector(".carousel-cell.zoomer") !== null;



function productAccordianClose() {
  // console.log("productAccordianClose called");
  let accordians = document.querySelectorAll("details.accordian");

  accordians.forEach((accordian) => {
    let summary = accordian.querySelector("summary")

    summary.addEventListener("click", function (event) {  
      accordians.forEach((otherAccordian) => { 
        if (
          otherAccordian !== accordian &&
          !otherAccordian.classList.contains('product-main__description')
        ) {
          otherAccordian.removeAttribute("open");
        }

        if (otherAccordian.querySelector('.js-read-more') !== null) {
          console.log("read more button found in other accordian");
          if (isReadMoreOpen) {
            let button = otherAccordian.querySelector(".js-read-more");
            onReadMoreClick(button);
            return; // Only run for the clicked accordian, not every accordian
          } else {
          }
        }
      });
    }); 
  });
}

function swatchSubmit() {

  var swatchSelect = document.querySelector('.js-swatch-redirect');

  if (swatchSelect) {
    swatchSelect.addEventListener('change', function() {
      var selectedOption = swatchSelect.options[swatchSelect.selectedIndex];
      var url = selectedOption.getAttribute('data-url');
      if (url) {
        window.location.href = url;
      }
    });
  } else {
    console.warn("Swatch select element not found.");
  }
}

swatchSubmit();

function runScripts() {
  
  let lastWidth = window.innerWidth;
  desktopFilterOverflow()
  // Helper functions for resize event listeners
  function handleResizeSwatchNames() {
    if (swatchCheck) {
      swatchNames();
    }
  }

  function handleResizeMobileMenu() {
    menuLinks.forEach((link) => {
      mobileMenu(link);
    });
  }

  function handleResizeReadMoreButton() {
    if (extendedDescription) {
      let buttons = document.querySelectorAll(".js-read-more");
      buttons.forEach((button) => {
        readMore(button);
      });
    }
  }

  function handleResizeRevealLogo() {
    if (!indexCheck && !productCheck) {
      revealLogo();
    }
  }

  if (productCheck) {
    productAccordianClose(); 
  }

  function handleResizeAnnBar() {
    if (annCheck) {
      annBar();
    }
  }

  function handleResizeSlider() {
    if (carouselCheck) {
      carousels.forEach((carousel) => {
        let flkty = Flickity.data(carousel);
        if (flkty) {
          flkty.destroy();
          slider(carousel);
        }
      });
    }
  }

  function handleResizeSliderWidth() {
    const currentWidth = window.innerWidth;
    if (currentWidth !== lastWidth) {
      lastWidth = currentWidth;
      handleResizeSlider();
    }
  }

  function handleResizeSearchForm() {
    if (searchInput) {
      searchInput.forEach((search) => {
        new SearchForm(search);
      });
    }
  }

  function handleResizeInfiniteScroll() {
    if (infiniteScrollInitialized) {
      infScrollReset();
    }
    // if (productGrid) {
    //   let latestProductGrid = document.querySelector(
    //     "#ProductGridContainer #product-grid"
    //   );
    //   append = "li.product-card";
    //   updateScrollPath(latestProductGrid)
    //   infScroll(latestProductGrid, append);
    // } else if (articleGrid) {
    //   let latestArticleGrid = document.querySelector("#article-grid");
    //   append = "li.article-card";
    //   updateScrollPath(latestArticleGrid)
    //   infScroll(latestArticleGrid, append);
    // }
  }

  function handleResizeMicroModal() {
    if (productCheck && sizeGuideCheck) {
      MicroModal.init({
        openClass: "is-open",
        disableScroll: true,
        disableFocus: false,
      });
    }
  }

  function handleResizeZoomProduct() {
    if (zoomerCheck) {
      
      zoomProduct(zoomers);
    }
  }

  // Product Scripts
  if (swatchCheck) {
    swatchNames();
  }

  window.addEventListener("resize", handleResizeSwatchNames);
  menuLinks.forEach((link) => {
    mobileMenu(link);
  });

  window.addEventListener("resize", handleResizeMobileMenu);

  window.addEventListener("resize", debounce(desktopFilterOverflow, 100));

  

  if  (extendedDescription) {
      let buttons = document.querySelectorAll(".js-read-more");
      buttons.forEach((button) => {
          if (!button.classList.contains('event-attached')) {
              button.classList.add('event-attached');
              readMore(button);
          }
      });
  }

  // window.addEventListener("resize", handleResizeReadMoreButton);

  if (!indexCheck && !productCheck) {
    revealLogo();
  }

  window.addEventListener("resize", handleResizeRevealLogo);

  if (annCheck) {
    annBar();
  }

  window.addEventListener("resize", handleResizeAnnBar);

  if (carouselCheck) {
    carousels.forEach((carousel) => {
      slider(carousel);
    });
  }

  window.addEventListener("resize", handleResizeSliderWidth);

  if (searchInput) {
    searchInput.forEach((search) => {
      new SearchForm(search);
    });
  }

  window.addEventListener("resize", handleResizeSearchForm);

  initInfiniteScroll();

  window.addEventListener("resize", handleResizeInfiniteScroll);

  if (productCheck && sizeGuideCheck) {
    MicroModal.init({
      openClass: "is-open",
      disableScroll: true,
      disableFocus: false,
    });
  }

  window.addEventListener("resize", handleResizeMicroModal);

  if (zoomerCheck) {
    // console.log("zoomers not null");
    zoomProduct(zoomers);
  }

  window.addEventListener("resize", handleResizeZoomProduct);
 
}

runScripts();
